import { analytics, useUser } from 'libs';
import { Select } from 'components/common';
import Filter from './Filter';

interface LenderTypeFilterProps {
  filters: { lender_type?: string[] };
  isPro?: boolean;
  onFilter: (update: { lender_type: string[] | null }) => void;
}

interface LenderTypeOption {
  label: string;
  value: string;
}

const LenderTypeFilter = ({ filters, isPro = false, onFilter }: LenderTypeFilterProps) => {
  const user = useUser();
  const disabled = isPro && !user.features.is_pro;

  const options: LenderTypeOption[] = [
    {
      label: 'Alternate (Defined Rates)',
      value: 'Alternate',
    },
    { label: 'Bank', value: 'Bank' },
    {
      label: 'Credit Union',
      value: 'Credit Union',
    },
    { label: 'Monoline', value: 'Monoline' },
  ];

  const onChange = (selected: LenderTypeOption[] | null, action: string, option?: LenderTypeOption) => {
    if (action === 'clear') {
      analytics.productSearch.filter({ lender_type: 'cleared' });
    }
    if (action === 'select-option') {
      analytics.productSearch.filter({ lender_type: option?.value });
    }

    const lenderTypes = selected?.map((selectedOption) => selectedOption.value) || [];
    const filter = { lender_type: lenderTypes.length ? lenderTypes : null };

    onFilter(filter);
  };

  const selectedOptions = () => {
    const lenderTypes = filters.lender_type || [];

    return lenderTypes.length ? options.filter((option) => lenderTypes.includes(option.value)) : null;
  };

  return (
    <Filter name="Lender Type" isPro={isPro}>
      <Select
        className="form-react-select"
        clearValue={null}
        closeMenuOnSelect={false}
        disabled={disabled}
        isMulti
        onChange={onChange}
        options={options}
        placeholder="All"
        selected={selectedOptions()}
        testId="filter-lender-type"
      />
    </Filter>
  );
};

export default LenderTypeFilter;
